import React from 'react';
import { Card, Box, Stack, Space, Skeleton, Group } from '@mantine/core';

export const SingleBookingSkeletonLoader = () => {
  return (
    <Box p='lg' bg='white' mih='100vh' data-testid="single-booking-skeleton">
      {/* Header and Preview Card */}
      <Card maw={600} mx='auto' shadow='none' withBorder>
        <Stack align="center">
          <Skeleton height={24} width={250} radius="xl" />
        </Stack>
        <Space h='md' />
        <Skeleton height={150} radius="md" />
        <Space h='md' />
        <Skeleton height={36} radius="md" />
      </Card>
      
      <Space h='md' />
      
      {/* Overall Status Card */}
      <Card maw={600} mx='auto' shadow='none' withBorder>
        <Stack>
          <Skeleton height={20} width={100} radius="xl" />
          <Skeleton height={60} radius="md" />
        </Stack>
      </Card>

      <Space h='md' />

      {/* Actions & Updates Card */}
      <Card maw={600} mx='auto' shadow='none' withBorder>
        <Stack>
           <Skeleton height={20} width={100} radius="xl" />
           <Group>
             <Skeleton height={36} width={120} radius="xl" />
             <Skeleton height={36} width={120} radius="xl" />
             <Skeleton height={36} width={120} radius="xl" />
           </Group>
           <Skeleton height={60} radius="md" />
           <Skeleton height={60} radius="md" />
        </Stack>
      </Card>
    </Box>
  );
};
